import translationService from '@services/requests/translation.service';


export let APP_TEXTS = {
    // menu
    //#region Menu Items
    MENU_FILE: { Id: "S120", Content: "FILE" },
    MENU_FILE_NEW_PROJECT: { Id: "S131", Content: "New Project" },
    MENU_FILE_OPEN_PROJECT: { Id: "S132", Content: "Open Project" },
    MENU_FILE_SAVE_PROJECT: { Id: "S133", Content: "Save Project" },
    MENU_FILE_EXIT: { Id: "S139", Content: "Exit" },

    MENU_OPTIONS: { Id: "S124", Content: "Options" },
    MENU_OPTIONS_COUNTRY_DESIGN_STANDARD: { Id: "S142", Content: "Country / Design standard" },
    MENU_OPTIONS_LANGUAGE: { Id: "S911", Content: "Language" },
    MENU_OPTIONS_UNITS: { Id: "S266", Content: "Units" },
    MENU_OPTIONS_USER_PROFILE: { Id: "S144", Content: "User Profile" },
    MENU_OPTIONS_ENVIRONMENT: { Id: "S347", Content: "Environment" },
    // MENU_OPTIONS_DIMENSIONS: { Id: "S2162", Content: "Dimensions" },

    MENU_HELP: { Id: "S128", Content: "HELP" },
    MENU_HELP_SUPPORT: { Id: "S126", Content: "SUPPORT" },
    MENU_HELP_WELCOME: { Id: "S362", Content: "Welcome" },
    MENU_HELP_PRIVACY_POLICY: { Id: "S732", Content: "Privacy Policy - Data processing and use" },
    MENU_HELP_ABOUT: { Id: "S127", Content: "ABOUT" },

    MENU_TECHNICAL: { Id: "S125", Content: "TECHNICAL" },
    MENU_CATALOG: { Id: "S2115", Content: "CATALOG" },
    //#endregion

    // tab titles
    //#region TABs titles
    OPTIONS: { Id: "S143", Content: "Options" },
    APPLICATIONS: { Id: "S110", Content: "1.Applications" },
    DIMENSIONS: { Id: "S112", Content: "2.Dimensions" },
    MATERIAL: { Id: "S111", Content: "3.Material" },
    LOADS: { Id: "S113", Content: "4.Loads" },
    DESIGN: { Id: "S1994", Content: "5.Design" },
    CALCULATE: { Id: "S115", Content: "6.Calculate" },
    //#endregion

    //#region Not sure if used anymore
    CLOSE: { Id: "S1968", Content: "Close" },
    APPLICATION: { Id: "S151", Content: "Application" },
    HEADER_DIMENSIONS: { Id: "S153", Content: "Dimensions" },
    HEADER_MATERIAL: { Id: "S1969", Content: "Material" },
    HEADER_LOADS: { Id: "S154", Content: "Loads" },
    HEADER_DESIGN: { Id: "S520", Content: "Design" },
    HEADER_CALCULATE: { Id: "S1970", Content: "Calculate" }, // it's used

    NAV_MATERIAL: { Id: "S1971", Content: "3.Material" },
    NAV_LOADS: { Id: "S1972", Content: "4.Loads" },
    NAV_DESIGN: { Id: "S1973", Content: "5.Design" },
    NAV_CALCULATE: { Id: "S1974", Content: "6.Calculate" },
    //#endregion

    //SettingsDisplay
    EUROPEAN_DESIGN_METHOD: { Id: "S913", Content: "European Design method" },
    // SETTINGS_DISPLAY_APPLICATION: { Id: "S151", Content: "Application" }, //duplicated string (APPLICATION)
    // SETTINGS_DISPLAY_SAFETY_BARRIER: { Id: "S161", Content: "Safety barrier" }, //duplicated string (SAFETY_BARRIER)
    SETTINGS_DISPLAY_STEEL: { Id: "S1975", Content: "Steel" },
    SETTINGS_DISPLAY_FLAT_BARS: { Id: "S1976", Content: "Flat bars" },
    FLAT_BARS: { Id: "S1977", Content: "Flat bars 50X12" },
    BASE_MATERIAL: { Id: "S152", Content: "Base material" },
    DESIGN_METHOD: { Id: "S155", Content: "Design method" },
    CRITERIA_FOR_SELECTION: { Id: "S156", Content: "Criteria for selection" },


    //UnitsForm
    DISTANCE_LABEL: { Id: "L1978", Content: "Distance:" },
    CENTIMETERS: { Id: "S1979", Content: "cm" },
    MILLIMETERS: { Id: "S1980", Content: "mm" },
    INCHES: { Id: "S1981", Content: "In" },
    WEIGHT_LABEL: { Id: "L1982", Content: "Weight:" },
    TEMPERATURE_LABEL: { Id: "L272", Content: "Temperature:" },
    STRENGTH_LABEL: { Id: "L269", Content: "Strength:" },
    POUND_PER_SQUARE_INCH: { Id: "S1983", Content: "psi" },
    NEWTON_SQUARE_MILLIMETERS: { Id: "S1984", Content: "N/mm²" },
    MOMENT_LABEL: { Id: "L271", Content: "Moment:" },
    LOAD_LABEL: { Id: "L270", Content: "Load:" },
    AREA_LABEL: { Id: "L268", Content: "Area:" },
    SQUARE_MILLIMETERS: { Id: "S1991", Content: "mm²" },
    SQUARE_CENTIMETERS: { Id: "S1992", Content: "cm²" },
    SQUARE_INCHES: { Id: "S1993", Content: "in²" },
    KILONEWTON: { Id: "S283", Content: "kN" },
    NEWTON: { Id: "S281", Content: "N" },
    DECANEWTON: { Id: "S282", Content: "daN" },
    POUND_FORCE: { Id: "S284", Content: "lbf" },
    NEWTON_METER: { Id: "S285", Content: "Nm" },
    KILONEWTON_METER: { Id: "S287", Content: "kNm" },
    DECANEWTON_METER: { Id: "S286", Content: "daNm" },
    FOOT_POUND_FORCE: { Id: "S288", Content: "lbf ft" },
    GRAM: { Id: "S2079", Content: "g" },
    KILOGRAM: { Id: "S2080", Content: "kg" },
    POUND: { Id: "S2081", Content: "lb" },
    FAHRENHEIT: { Id: "S290", Content: "°F" },
    CELSIUS: { Id: "S289", Content: "°C" },

    //tab Options
    COUNTRY: { Id: "S299", Content: "Country:" },
    DESIGN_STANDARDS: { Id: "S912", Content: "Design standard:" },
    LANGUAGE: { Id: "S300", Content: "Language:" },
    PROFILE_TYPES: { Id: "S1091", Content: "Profile type:" },
    PROJECT_NAME: { Id: "S556", Content: "Project name:" },
    EXTEND_TIMEOUT: { Id: "S2147", Content: "Extend the timeout period of a calculation:" },

    //labels
    APPLICATIONS_LABEL_PLATE_MATERIAL_STEEL_GRADE: { Id: "L502", Content: "Plate material (Steel Grade):" },
    APPLICATIONS_LABEL_PROFILE_FAMILY: { Id: "L168", Content: "Profile:" },
    Applications_LABEL_PROFILE_SIZE: { Id: "L167", Content: "Profile size (Section size) :" },

    CALCULATE_LABEL_LOADS_ON_ANCHORS: { Id: "L598", Content: "Loads on anchors:" },
    //  CALCULATE_LABEL_ANCHOR:{Id:"S443", Content:"Anchor"},

    //Material Reinforcements and conditions
    //labels
    MATERIAL_LABEL_PLATE_REINFORCEMENT: { Id: "L181", Content: "Plate reinforcement (rebar spacing)" },
    MATERIAL_LABEL_EDGE_REINFORCEMENT: { Id: "L182", Content: "Edge reinforcement" },
    MATERIAL_LABEL_LONG_TERM_TEMPERATURE: { Id: "L561", Content: "Long term temperature:" },
    MATERIAL_LABEL_SHORT_TERM_TEMPERATURE: { Id: "L560", Content: "Short term temperature:" },
    MATERIAL_LABEL_INSTALLATION_CONDITIONS: { Id: "L186", Content: "Installation conditions" },
    MATERIAL_LABEL_TENSSION_LOAD_CONDITIONS: { Id: "L920", Content: "Tension load conditions" },
    MATERIAL_LABEL_SHEAR_LOAD_CONDITIONS: { Id: "S921", Content: "Shear load conditions" },

    //types
    //GeneralCalculation
    GENERAL_CALCULATION_STAND_OFF_LABEL: { Id: "L262", Content: "Stand-off:" },


    //Global Strings
    TYPE_LABEL: { Id: "L169", Content: "Type:" },

    //SafetyBarrier
    SAFETY_BARRIER_BASE_PLATE_LABEL: { Id: "L1881", Content: "Base plate:" },
    SAFETY_BARRIER_ONE_SIDE: { Id: "S1909", Content: "One side" },
    SAFETY_BARRIER_FIRE_ATTACK: { Id: "S526", Content: "Fire attack" },
    SEISMIC_PERFORMANCE_CATEGORY_C1: { Id: "S931", Content: "Seismic Performance Category C1" },
    SEISMIC_PERFORMANCE_CATEGORY_C2: { Id: "S932", Content: "Seismic Performance Category C2" },
    SAFETY_BARRIER_CHECK_PROFILE_RESISTANCE: { Id: "S254", Content: "Check profile resistance" },
    SAFETY_BARRIER_CHECK_PROFILE_DESCRIPTION:
    {
        Id: "S250",
        Content: "Check the profile resistance to guarantee the mechanical resistance and the limit deviation"
    },
    SAFETY_BARRIER_MAXIMUM_DEVIATION: { Id: "S628", Content: "Maximum Deviation" },
    SAFETY_BARRIER_EDGE_SLAB_BUTTON: { Id: "S170", Content: "Edge slab" },
    SAFETY_BARRIER_FLOOR_SLAB_BUTTON: { Id: "S171", Content: "Floor slab" },
    SAFETY_BARRIER_PEDESTAL_BUTTON:{Id:"S172",Content:"Pedestal"},
    SAFETY_BARRIER_STAIRS_BUTTON:{Id:"S173",Content:"Stairs"},
    SAFETY_BARRIER_BETWEEN_WALLS_BUTTON:{Id:"S879",Content:"Between walls"},
    SAFETY_BARRIER_PREDEFINED_BASE_PLATE: { Id: "S2171", Content: "Pre-defined base plate" },
    SAFETY_BARRIER_MANUFACTURER: { Id: "S2172", Content: "Manufacturer" },
    SAFETY_BARRIER_DESIGNATION: { Id: "S2173", Content: "Designation" },
    SAFETY_BARRIER_CLADDING_NONE: { Id: "S2175", Content: "None" },
    SAFETY_BARRIER_CLADDING_GLASS: { Id: "S2176", Content: "Glass" },
    SAFETY_BARRIER_CLADDING_METALLIC: { Id: "S2185", Content: "Metallic" },
    SAFETY_BARRIER_CLADDING: { Id: "S2177", Content: "Cladding" },

    //descriptions
    MATERIAL_REINFORCEMENT_DESCRIPTION: {
        Id: "S483",
        Content: "Reinforcement to limit the crack width to Wk ~ "
    },
    MATERIAL_REINFORCEMENT_DESCRIPTION2: {
        Id: "S822",
        Content: "The following parameters are taken into account in the design of adhesive anchors only."
    },
    MATERIAL_SERVICE_TEMPERATURE_RANGE: {
        Id: "S1100",
        Content: "Service temperature range:"
    },
    MATERIAL_SERVICE_TEMPERATURE_RANGE_DESCRIPTION: {
        Id: "S824",
        Content: "(Range of ambient temperature after installation and during the lifetime of the anchorage.)"
    },
    MATERIAL_LONG_TERM_TEMP_DESCRIPTION: {
        Id: "S826",
        Content: "Service temperature range, which will be approximately constant over significant period of time."
    },
    MATERIAL_SHORT_TERM_TEMP_DESCRIPTION: {
        Id: "S828",
        Content: "Service temperature range, which vary over short intervals, e.g. day/night cycles and freeze/thaw cycles."
    },


    //APPLICATION
    GENERAL_CALCULATION: { Id: "S160", Content: "General calculation" },
    BRACKET_ATTACHMENT: { Id: "S162", Content: "Bracket attachment" },
    SAFETY_BARRIER: { Id: "S161", Content: "Safety barrier" },
    REBAR_REINFORCEMENT: { Id: "S165", Content: "Rebar reinforcement" },
    WOOD_CONNECTION: { Id: "S2186", Content: "Wood connection" },

    //CALCULATE
    INSTALLATION_DATA: { Id: "S259", Content: "Installation data" },
    INSTALLATION_METHOD: { Id: "S260", Content: "Installation method" },
    CHECK_BASE_PLATE_THICKNESS: { Id: "S820", Content: "Check base plate thickness" },
    // CALCULATE_LOADS: { Id: "S154", Content: "Loads" }, // duplicated string (HEADER_LOADS)
    // CALCULATE_PDF:{Id:"S2077",Content:"PDF"},
    CALCULATE_ESR: { Id: "S959", Content: "ESR" },
    CALCULATE_ETA: { Id: "S258", Content: "ETA" },
    // CALCULATE_BIM:{Id:"S2078",Content:"BIM"},
    // CALCULATE_ACAD:{Id:"S2079",Content:"ACAD"},
    CALCULATE_PROFILE_RESISTANCE: { Id: "S714", Content: "Profile resistance" },
    //CalculateAnchorSelection
    ANCHOR_SELECTION_ALL_RESULTS: { Id: "S527", Content: "All results" },
    ANCHOR_SELECTION_OK: { Id: "S458", Content: "OK" },
    ANCHOR_SELECTION_NOT_OK: { Id: "S459", Content: "Not OK" },
    ANCHOR_SELECTION_TIMEOUT: { Id: "S2146", Content: "Calculation timeout" },
    ANCHOR_SELECTION_ANCHOR_TYPE: { Id: "S528", Content: "Anchor Type" },
    ANCHOR_SELECTION_STEEL_TYPE: { Id: "S533", Content: "Steel Type" },
    ANCHOR_SELECTION_ALL_PRODUCTS: { Id: "S531", Content: "All products" },
    ANCHOR_SELECTION_ALL_DIAMETERS: { Id: "S530", Content: "All diameters" },
    ANCHOR_SELECTION_BUTTON_REMOVE_FILTERS: { Id: "S534", Content: "Remove filters" },
    ANCHOR_SELECTION_PRODUCT: { Id: "S440", Content: "Product" },
    ANCHOR_SELECTION_ANCHORAGE_LBD: { Id: "S724", Content: "Anchorage Lbd" },
    ANCHOR_SELECTION_DIMENSION: { Id: "S441", Content: "Dimension" },
    ANCHOR_SELECTION_DF: { Id: "S903", Content: "df" },
    ANCHOR_SELECTION_UTILIZATION: { Id: "S373", Content: "Utilization" },
    ANCHOR_SELECTION_NAME: { Id: "S1882", Content: "Name" },
    ANCHOR_SELECTION_ALL_PRODUCT_RANGES: { Id: "S2097", Content: "All product ranges" },

    // ANCHOR_SELECTION_NAME:{ Id:"xxx", Content:"xxx"},
    //CalculateHeader
    CALCULATE_HEADER_TENSILE: { Id: "S371", Content: "Tensile" },
    CALCULATE_HEADER_SHEAR: { Id: "S372", Content: "Shear" },
    CALCULATE_HEADER_DESIGN_METHOD_LABEL: { Id: "L1883", Content: "Design method applied:" },
    CALCULATE_HEADER_ANCHOR_SELECTED: { Id: "S369", Content: "Anchor selected:" },
    CALCULATE_HEADER_REBAR_SELECTED: { Id: "S725", Content: "Rebar selected:" },
    //CalculateInstallationData
    CALCULATE_INSTALLATION_DATA_MM: { Id: "S273", Content: "mm" },
    //CalculateLoads
    //loads on anchors?
    CALCULATE_LOADS_ANCHOR: { Id: "S443", Content: "Anchor" },
    CALCULATE_LOADS_TENSILE: { Id: "S444", Content: "Tensile" },
    CALCULATE_LOADS_SHEAR_X: { Id: "S445", Content: "Shear[x]" },
    CALCULATE_LOADS_SHEAR_Y: { Id: "S446", Content: "hear[y]" },
    CALCULATE_LOADS_ON_ANCHORS: { Id: "S1884", Content: "Loads on anchors" },
    //CalculateResultsOfDesign
    // EU
    CALCULATE_RESULTS_DESIGN_TENSION: { Id: "S427", Content: "Tension" },
    CALCULATE_RESULTS_DESIGN_kN: { Id: "S428", Content: "kN" },
    CALCULATE_RESULTS_DESIGN_CONE_FAILURE: { Id: "S430", Content: "Concrete cone failure" },
    CALCULATE_RESULTS_DESIGN_SPLITTING_FAILURE: { Id: "S431", Content: "Splitting failure" },
    CALCULATE_RESULTS_DESIGN_N: { Id: "S281", Content: "N" },
    //Rd,c
    //Rd,sp
    //Rd,s
    //Rd,P
    //V
    CALCULATE_RESULTS_DESIGN_STEEL_FAILURE: { Id: "S401", Content: "Steel failure" },
    CALCULATE_RESULTS_DESIGN_PULL_OUT_FAILURE: { Id: "S433", Content: "Pull-out failure" },
    CALCULATE_RESULTS_DESGIN_EDGE_FAILURE: { Id: "S414", Content: "Concrete edge failure" },
    CALCULATE_RESULTS_DESGIN_PRYOUT_FAILURE: { Id: "S437", Content: "Concrete pryout failure" },
    CALCULATE_RESULTS_DESGIN_UTILIZATION_EQUATION: { Id: "S438", Content: "Utilization equation" },
    CALCULATE_RESULTS_DESIGN_CONCRETE_FAILURE: { Id: "S2120", Content: "Concrete failure" },
    // ICC
    CALCULATE_RESULTS_DESIGN_CONCRETE_BREAKOUT: { Id: "S974", Content: "Concrete breakout strength" },
    CALCULATE_RESULTS_DESIGN_STEEL_STRENGTH: { Id: "S975", Content: "Steel strength" },
    CALCULATE_RESULTS_DESIGN_PULLOUT_STRENGTH: { Id: "S976", Content: "Pullout strength" },
    CALCULATE_RESULTS_DESIGN_PRYOUT_STRENGTH: { Id: "S978", Content: "Pryout strength" },
    CALCULATE_RESULTS_DESIGN_BOND_STRENGTH: { Id: "S979", Content: "Bond strength" },
    // ANZ
    CALCULATE_RESULTS_DESIGN_MOMENT: { Id: "S972", Content: "Moment" },
    CALCULATE_RESULTS_DESIGN_CONCRETE_CAPACITY: { Id: "S980", Content: "Concrete capacity" },
    CALCULATE_RESULTS_DESIGN_STEEL_CAPACITY: { Id: "S981", Content: "Steel capacity" },
    CALCULATE_RESULTS_DESIGN_PULL_THROUGH_CAPACITY: { Id: "S982", Content: "Pull through capacity" },
    CALCULATE_RESULTS_DESIGN_CONCRETE_EDGE_CAPACITY: { Id: "S983", Content: "Concrete edge capacity" },
    CALCULATE_RESULTS_DESIGN_BENDING_CAPACITY: { Id: "S973", Content: "Bending capacity" },
    // Masonry
    CALCULATE_RESULTS_DESIGN_PULL_THROUGH_CAPACITY_PER_ANCHOR: { Id: "S994", Content: "Pull-through capacity per anchor:" },
    CALCULATE_RESULTS_DESIGN_SHEAR_CAPACITY_PER_ANCHOR: { Id: "S2072", Content: "Shear capacity per anchor:" },

    //JobSiteTest - ResultsTable
    MASONRY_RESULTS_INFO: { Id: "S2139", Content: "Enter values measured at the ultimate load" },
    MASONRY_RESULTS_TABLE_N1TEST: { Id: "S2091", Content: "N1test" },
    MASONRY_RESULTS_TABLE_V1TEST: { Id: "S2092", Content: "V1test" },

    //CalculateThickness
    CALCULATE_THICKNESS_DESCRIPTION:
    {
        Id: "S821",
        Content:
            "A Finite Element Method is used to check the minimum thickness required for the base plate " +
            "(in order to be stiff enough). " +
            "Depending on the parameters, this calculation may take from a few seconds to a few minutes."
    },

    CALCULATE_PLATE_THICKNESS_OPTIMIZATION:
        { Id: "S845", Content: "Enable plate thickness optimization" },

    THICKNESS_FEM_CALCULATION_NOT_LAUNCHED:
        { Id: "S835", Content: "FEM calculation has not been launched or is not valid." },
    CALCULATE_FEM_LOWER_BASE_PLATE_THICKNESS: { Id: "S875", Content: "You can use a lower base plate thickness." },
    CALCULATE_FEM_CHANGE_PLATE_THICKNESS:
    {
        Id: "S831",
        Content: "The correct plate thickness should be the one from right. Please change your plate thickness in your project."
    },
    CALCULATE_FEM_PLATE_THICKNESS_CORRECT: { Id: "S829", Content: "The plate thickness is correct" },
    CALCULATE_FEM_PLATE_THICKNESS_NOT_CORRECT: { Id: "S830", Content: "The plate thickness is not correct" },
    CALCULATE_FEM_BASE_PLATE_THICKNESS: { Id: "S621", Content: "Base plate thicknes:" },
    CALCULATE_FEM_MAXIMUM_DISPLACEMENT: { Id: "S839", Content: "Maximum displacement:" },
    CALCULATE_FEM_RELATIVE_DISPLACEMENT: { Id: "S832", Content: "Relative displacement:" },
    CALCULATE_FEM_MAX_VON_MISES_STRESS: { Id: "S833", Content: "Max Von Mises stress:" },

    CALCULATE_THICKNESS_START: { Id: "S846", Content: "Start" },
    CALCULATE_THICKNESS_CANCEL: { Id: "S847", Content: "Cancel" },

    // CalculateProfileResistance
    CALCULATE_PROFILE_SUITABLE: { Id: "S905", Content: "The profile is suitable" },
    CALCULATE_PROFILE_NOT_SUITABLE: { Id: "S906", Content: "The profile is not suitable" },
    CALCULATE_PROFILE_MATERIAL: { Id: "S166", Content: "Material:" },
    CALCULATE_PROFILE_CONDITIONS: { Id: "S559", Content: "Conditions:" },
    CALCULATE_PROFILE_DEVIATION_WLIM: { Id: "S715", Content: "Deviation Wlim" },
    CALCULATE_PROFILE_IY_WLIM: { Id: "S716", Content: "Iy at Wlim" },
    CALCULATE_PROFILE_IY: { Id: "S717", Content: "Iy profile" },

    // Report
    CALCULATE_REPORT_SHORT: { Id: "S2102", Content: "Short version" },
    CALCULATE_REPORT_DETAILED: { Id: "S2103", Content: "Detailed version" },
    CALCULATE_REPORT_SHEET_SETTINGS: { Id: "S587", Content: "Calculation sheet settings" },
    CALCULATE_REPORT_SHEET_INFO: {
        Id: "S709",
        Content: "A PDF document is going to be saved on your computer. Just indicate the project " +
            "details (if desired) and the output language. Press OK and save your report in the folder of your choice on the disk. " +
            "Open the PDF file with your usual pdf viewer."
    },
    CALCULATE_REPORT_PROJECT_DETAILS: { Id: "S589", Content: "Project details" },
    CALCULATE_REPORT_PROJECT_NAME: { Id: "S556", Content: "Project name:" },
    CALCULATE_REPORT_FASTENING_POINT: { Id: "S557", Content: "Fastening point:" },
    CALCULATE_REPORT_LOCATION: { Id: "S590", Content: "Location:" },
    CALCULATE_REPORT_CONTACT_NAME: { Id: "S555", Content: "Contact name:" },
    CALCULATE_REPORT_COMPANY_NAME: { Id: "S293", Content: "Company name:" },
    CALCULATE_REPORT_PHONE_NUMBER: { Id: "S296", Content: "Phone number:" },
    CALCULATE_REPORT_MAIL_ADDRESS: { Id: "S591", Content: "Mail address:" },
    CALCULATE_REPORT_COMMENT: { Id: "S558", Content: "Comment:" },
    CALCULATE_REPORT_LANGUAGE_SETTINGS: { Id: "S627", Content: "Language settings:" },
    CALCULATE_REPORT_SHOW_DIM_3D: { Id: "S2160", Content: "Show dimensions in 3D view:" },

    //RebarDesignCalculation
    REBAR_DESIGN_XNC: { Id: "S1014", Content: "Xnc" },
    REBAR_DESIGN_K1: { Id: "S1070", Content: "k1" },
    REBAR_DESIGN_K2: { Id: "S1071", Content: "k2" },
    REBAR_DESIGN_K3: { Id: "S1072", Content: "k3" },
    REBAR_DESIGN_ANCHORAGE_LBD: { Id: "S724", Content: "Anchorage Lbd" },
    REBAR_DESIGN_DEVELOPMENT_LENGTH: { Id: "S1885", Content: "Design development length Lsy,t" },
    REBAR_DESIGN_NUMBER_REBARS: { Id: "S1886", Content: "Number of Rebars" },
    REBAR_DESIGN_TENSILE_CAPACITY: { Id: "S1887", Content: "Design tensile capacity (per rebar)" },
    REBAR_DESIGN_ULTIMATE_LOAD: { Id: "S1888", Content: "Ultimate load per rebar FRd" },
    REBAR_DESIGN_BOND_RESISTANCE: { Id: "S1889", Content: "Design bond resistance fbd" },
    REBAR_DESIGN_FACTOR: { Id: "S1890", Content: "α2 factor" },
    REBAR_DESIGN_FIRE_DURATION: { Id: "S1891", Content: "Fire duration" },
    REBAR_DESIGN_ULTIMATE_LOAD_FIRE_RESISTANCE: {
        Id: "S1892",
        Content: "Ultimate load for fire resistance FRd,fi"
    },
    REBAR_DESIGN_ANCHORAGE_FIRE_RESISTANCE:
        { Id: "S1893", Content: "Anchorage Lbd for fire resistance" },


    //DESIGN
    //GeneralCalculationDesign
    FIXED_ANCHORAGE_DEPTH: { Id: "S549", Content: "Specify a fixed depth" },
    EMBEDMENT_DEPTH_OPTION: { Id: "S2132", Content: "Embedment depth:" },
    FIXED_EMBEDMENT_DEPTH_OPTION: { Id: "S2133", Content: "Fixed embedment depth: hef" },
    STANDARD_EMBEDMENT_DEPTH_OPTION: { Id: "S2134", Content: "Standard embedment depth" },
    OPTIMISED_EMBEDMENT_DEPTH: { Id: "S2131", Content: "Optimised embedment depth" },
    FIXED_ANCHORAGE_HEF_LABEL: { Id: "L501", Content: "Fixed anchorage hef:" },
    FIXED_ANCHORAGE_ADHESIVE_ANCHOR: {
        Id: "S499",
        Content: " Only for adhesive anchor design with variable embedment." +
            "In the case when no value is specified, th anchor depth is calculated" +
            "automatically by the program." +
            "If you want to specify a fixed depth the calculation takes info account" +
            "the value specified."
    },
    FIXED_ANCHORAGE_ADHESIVE_MECHANICAL_ANCHOR: {
        Id: "S500",
        Content: "For design calculation with mechanical anchors and" +
            "adhesive anchors without flexible embedment," +
            "this value is not taken info account."
    },
    EMBEDMENT_DEPTH_INFO_MESSAGE: {
        Id: "S2170",
        Content: 'Modify the calculation option in the DESIGN tab, ' +
            'select the option "Optimized embedment depth" to find a solution'
    },
    ANCHOR_DEPTH_TITLE: { Id: "S2095", Content: "Anchor depth" },

    //method
    METHOD_ULTIMATE_LIMIT: {
        Id: "S246",
        Content: "Design the resistance of anchorages in the ultimate limit state," +
            "according to Method A Annex C of ETA Guideline 001" +
            "or EOTA TR029 (depends on the method given in the relevant ETA)."
    },

    METHOD_MECHANICAL_AND_ADHESIVE_ANCHORS: {
        Id: "S907",
        Content: "Design the resistance of anchorages in the ultimate limit state," +
            "according to CEN/TS 1992-4-4 (mechanical anchors) or CEN/TS 1991-4-5" +
            "(adhesive anchors) (depends on the method given in the relevant ETA)."
    },

    METHOD_CHEMICAL_ANCHORS: {
        Id: "S908", Content: " Design of variable anchorage" +
            "for adhesive anchors according to CEN/TS 1992-4-5 (chemical anchors)" +
            "with commercial studs 5.8, 8.8, 10.9, A4 and HCR."
    },

    METHOD_FIRE_EXPOSURE: {
        Id: "S248",
        Content: "Design the resistance of anchorages under fire exposure," +
            "according to TR020."
    },

    METHOD_SEISMIC_CALCULATION: { Id: "S547", Content: "Seismic calculation" },
    METHOD_SEISMIC_CALCULATION_DESCRIPTION: {
        Id: "S548",
        Content: "Design the resistance of anchorages under seismic actions," +
            "according to TR045."
    },

    CALCULATION_SEISMIC_ZONE_DTA: {
        Id: "S782",
        Content: "Calculation in Seismic zone according to DTA nb. 3/11-684 (CSTB French approval)."
    },

    METHOD_EUROPEAN: { Id: "S1999", Content: "EN 1992-4" },
    METHOD_EUROPEAN_RAMSET: { Id: "S1998", Content: "European/NZS 3101" },
    METHOD_EUROPEAN_NAME: { Id: "S2002", Content: "{0} for static, quasi-static loading" },
    METHOD_ICC_NAME: { Id: "S2003", Content: "ACI 318-14 Design for static, quasi-static loading" },
    METHOD_AS5216_NAME: { Id: "S2008", Content: "AS 5216:2018 Design for static, quasi-static loading" },
    METHOD_CSA_NAME: { Id: "S2010", Content: "CSA Design for Static, quasi-static loading" },
    METHOD_ANZ_NAME: { Id: "S2007", Content: "ANZ Design Method" },
    METHOD_ANNEXC_NAME: { Id: "S2148", Content: "ETAG 001 Annex C Design for static, quasi-static loading" },

    //Rebar
    DESIGN_REBAR_EUROCODE2: { Id: "S1177", Content: "eurocode 2" },
    DESIGN_REBAR_APPLICATION: { Id: "S1178", Content: "(rebar application)" },
    REBAR_ANCHORING_LENGTH: {
        Id: "S252",
        Content: "Calculation method to define the rebar anchoring length."
    },

    DESIGN_REBAR_FIRE: { Id: "S1179", Content: "FIRE" },
    DESIGN_REBAR_CALCULATION: { Id: "S1180", Content: "calculation" },
    DESIGN_RESISTANCE_EC2: {
        Id: "S869",
        Content: "Design the resistance of anchorages under fire exposure according to EC2"
    },

    DESIGN_REBAR_MINUTE: { Id: "S361", Content: "minute" },
    DESIGN_REBAR_LABEL_EUROCODE2: { Id: "L1906", Content: "eurocode 2:" },
    DESIGN_REBAR_LABEL_VARIO: { Id: "L1907", Content: "VARIO:" },
    DESIGN_REBAR_ADHESIVE_METHOD: { Id: "S1908", Content: "Adhesive method" },
    DESIGN_REBAR_LABEL_AS3600: { Id: "L1991", Content: "AS 3600" },
    DESIGN_REBAR_AS3600_DESCRIPTION: {
        Id: "S1995",
        Content: "Strength limit state design for multiple bars in concrete elements according to AS 3600-2009 clause 13.1.2.2."
    },
    DESIGN_REBAR_LABEL_AS5216: { Id: "S2169", Content: "AS 5216 : 2021-Appendix D" },





    //LoadSelector
    LOAD_SEELECTOR_DECISIVE_COMBINATION: { Id: "S1894", Content: "Decisive combination" },
    METHOD_POST_INSTALLED_MECHANICAL_FASTENERS:
        { Id: "S1895", Content: "EN1992-4:2017 for post-installed mechanical fasteners" },
    METHOD_POST_INSTALLED_BONDED_FASTENERS:
        { Id: "S1896", Content: "EN1992-4:2017 for post-installed bonded fasteners" },
    METHOD_ETAG: { Id: "S1897", Content: "etag" },
    METHOD_CALCULATION: { Id: "S1898", Content: "calculation" },
    METHOD_A_DESIGN_RESISTANCE:
    {
        Id: "S1899",
        Content: "Design the resistance of anchorages in the ultimate limit state, according to Method A"
    },

    METHOD_ANNEX_C_ETA_GUIDANCE001: { Id: "S1900", Content: "Annex C of ETA Guidance 001." },

    METHOD_VARIABLE_ANCHORAGE_ADHESIVE_ANCHORS:
    {
        Id: "S859",
        Content: " Design of variable anchorage for adhesive anchors according to TR029," +
            "with commercial studs 5.8, 8.8, 10.9, A4 and HCR."
    },

    METHOD_CASE_NO_VALUE:
    {
        Id: "S860",
        Content: "In the case when no value is specified," +
            "the anchor depth is calculated automatically by the program." +
            "If you want to specify a fixed depth the calculation takes into account the value specified."
    },

    DEISGN_RESISTANCE_ULTIMATE_STATE:
    {
        Id: "S1903",
        Content: "Design the resistance of anchorages in the ultimate limit state, according to"
    },

    DESIGN_RESISTANCE_ULTIMATE_STATE_ACCORDING_TO: { Id: "S1904", Content: "1992-4-4 (mechanical anchors)." },
    DESIGN_METHOD_FIRE: { Id: "S1905", Content: "fire" },
    DESIGN_LOADS_COMBINATION_ANCHOR_DEPTH: { Id: "S2094", Content: "Loads combination & Anchor depth" },
    DESIGN_LOADS_COMBINATION: { Id: "S2140", Content: "Loads combination" },

    //Dimension
    //BracketAttachment
    BRACKET_ATTACHMENT_TITLE_BASE_PLATE: { Id: "S174", Content: "Base plate" },
    BRACKET_ATTACHMENT_TITLE_AXIS_POSITION: { Id: "S190", Content: "Axis position" },
    BRACKET_ATTACHMENT_TITLE_BASE_PLATE_FACTOR: { Id: "S291", Content: "Base plate factor" },

    //BasePlateFactor
    FACTOR: { Id: "L1985", Content: "Factor" },

    //spacing
    SPACING_SPECIFY_COORDINATES: { Id: "L475", Content: "Specify coordinates" },
    PANEL_VERTICES: { Id: "S2093", Content: "Panel vertices" },
    SCREW_POSITIONS: { Id: "S2098", Content: "Screw positions" },

    //BasePlate
    BASE_PLATE_DIMENSION_LABEL: { Id: "L193", Content: "Dimensions of the base plate" },
    BASE_PLATE_THICKNESS_LABEL: { Id: "L196", Content: "Thickness" },
    BASE_PLATE_SPACING_LABEL: { Id: "L198", Content: "Spacing" },
    BASE_PLATE_EDGE_DISTANCE_LABEL: { Id: "L201", Content: "Edge distance" },
    POSITION_TABLE_INDEX: { Id: "S463", Content: "Index" },
    POSITION_TABLE_REMOVE: { Id: "S1910", Content: "Remove" },
    POSITION_TABLE_ADD: { Id: "S1911", Content: "Add" },
    TENSION_ZONE: { Id: "S593", Content: "Tension zone" },
    COMPRESSION_ZONE: { Id: "S594", Content: "Compression zone" },
    BASE_PLATE_ORIENTATION: { Id: "S2116", Content: "Base plate orientation:" },

    //BasePlateFactor
    CLEARANCE_DIAMETER: { Id: "S1912", Content: ": clearance diameter of the base plate" },
    DISTANCE_TO_THE_EDGE: { Id: "S1913", Content: ": distance to the edge of the base plate" },
    SELECT_FACTOR_USED: {
        Id: "S818",
        Content: "Select the factor which should be used" +
            "(recommends to use 1.5 or refer to local codes for recommended factor)"
    },

    //PedestalDimensions
    PEDESTAL_THICKNESS: { Id: "L814", Content: "Pedestal thickness" },
    SLAB_THICKNESS: { Id: "L815", Content: "Slab thickness" },
    PEDESTAL_WIDTH: { Id: "L816", Content: "Pedestal width" },
    FINISH_SLAB_HEIGHT: { Id: "L897", Content: "Finish slab height" },

    //SafetyBarrierDimensions
    SAFETY_BARRIER_HEIGHT_LABEL: { Id: "L211", Content: "Height of safety barrier" },
    DISTANCE_BETWEEN_POSTS_LABEL: { Id: "L213", Content: "Distance between posts" },
    CLADDING_PROPERTIES_LABEL: {Id: "S2179", Content: 'Cladding properties'},
    SAFETY_BARRIER_DIMENSIONS_TITLE: { Id: "S192", Content: "Safety barrier dimensions" },
    PEDESTAL_DIMENSIONS_TITLE: { Id: "S521", Content: "Pedestal dimensions" },
    STAIRS_DIMENSIONS_TITLE: { Id: "S616", Content: "Stairs dimensions" },
    WALL_DIMENSIONS_TITLE: { Id: "S890", Content: "Wall dimensions" },

    //LoadTabs
    DEAD_WIND_LOAD_TITLE: { Id: "S2178", Content: "Dead Load and Wind Load (cladding option)" },
    DEAD_LOAD_TITLE: { Id: "S2217", Content: "Dead Load" },
    WIND_LOAD_TITLE: { Id: "S2181", Content: "Wind Load" },
    WIND_ZONE_TITLE: { Id: "S2182", Content: "Wind Zone:" },
    WIND_VB_TITLE: { Id: "2208", Content: "Vb:" },
    BUILDING_DESCRIPTION_TITLE:{ Id: "S2183", Content: "Building description" },
    GROUND_SELECTION_TITLE: { Id: "S2184", Content: "Ground:" },
    IS_EDGE_CHECKBOX: { Id: "S2211", Content: "Distance from building edge < 2m" },
    //SlottedHoles
    SLOTTED_HOLES_DESCRIPTION: {
        Id: "S868",
        Content: "Slotted holes cannot be used with this anchor arrangement"
    },
    //StandOffParameters
    DIMENSION_L: { Id: "L208", Content: "Stand-off dimension L:" },
    RESTRAINT_LEVEL: { Id: "L209", Content: "Restraint level:" },
    MORTAR_STRENGTH: { Id: "L1914", Content: "Mortar strength" },

    //WallDimensions
    WALL_WIDTH: { Id: "L891", Content: "Wall width" },

    //GeneralCalc
    SLOTTED_HOLES_TITLE: { Id: "S189", Content: "Slotted holes" },
    STAND_OFF_PARAMETERS_TITLE: { Id: "S191", Content: "Stand-off parameters" },

    //Rebar
    //DimensionConcreteMEmeber

    REINFORCEMENT_PARAMETERS_TITLE: { Id: "S516", Content: "Reinforcement parameters" },
    DIMENSIONS_CONCRETE_MEMBER_TITLE: { Id: "S515", Content: "Dimensions concrete member" },

    //ReinforcementParameters
    GRADE_STEEL_BAR: { Id: "S876", Content: "Grade steel bar:" },
    MAX_INSTALLATION_LENGTH: { Id: "S518", Content: "Max. installation length" },
    REINFORCEMENT_PARAMETERS_LAYERS: { Id: "S1915", Content: "Layers" },
    //WoodConnectionTab
    WOOD_CONNECTION_MATERIAL: { Id: "S2187", Content: "Plate material:" },
    WOOD_CONNECTION_PANEL: { Id: "S2188", Content: "Wood panel" },
    WOOD_CONNECTION_CROSS_SECTION: { Id: "S2231", Content: "Cross Section:" },
    WOOD_CONNECTION_THICKNESS_E1: { Id: "S2232", Content: "Thickness E1 =" },
    WOOD_CONNECTION_THICKNESS_E2: { Id: "S2233", Content: "Thickness E2 =" },
    //Loads
    //BracketDesignLoading
    LOAD_APPLICATION_POINT: { Id: "L235", Content: "Application point of the load" },
    LOADS_ON_BRACKET: { Id: "L239", Content: "Loads applied on the bracket" },
    BRACKET_DESIGN_LOAD_F: { Id: "S240", Content: "Load F" },
    BRACKET_DESIGN_LOAD_NR: { Id: "S241", Content: "Load NR" },
    BRACKET_DESIGN_WEIGHT_P: { Id: "S242", Content: "Weight P" },

    //GeneralLoading
    //characteristicsLoading
    DEAD_LOAD_D: { Id: "S355", Content: "Dead Load, D" },
    LIVE_LOAD_L: { Id: "S356", Content: "Live Load, L" },
    TEMPORARY_LOAD_A: { Id: "S357", Content: "Temporary load, A" },
    ULTIMATE_LOADS: { Id: "S546", Content: "Ultimate loads" },
    PARTIAL_SAFETY_FACTOR: { Id: "S243", Content: "Partial safety factor" },
    DESIGN_LOADING: { Id: "S595", Content: "Design loading" },
    CALCULATE_DESIGN_LOAD: { Id: "S1916", Content: "Calculate Design load" },
    DESIGN_LOADS_INCLUDING_PARTIAL_FACTOR: {
        Id: "S1917",
        Content: "Design loads including partial safety factor"
    },
    EU_METHOD_FOR_SEISMIC_AND_FIRE_DESIGN: {
        Id: "S1918",
        Content: "For seismic and fire design, use European Design method."
    },
    EN1992_METHOD_FOR_SEISMIC_AND_FIRE_DESIGN: {
        Id: "S2150",
        Content: "For seismic and fire design, select the EN 1992-4 design method."
    },
    DESIGN_LOADS_RAMSET_MASONRY: {
        Id: "S2138",
        Content: "Working load limit"
    },

    //DesignLoading
    LOADS_COMBINATION_NAME: { Id: "S2137", Content: "Combination {0}" },
    LOADS_TYPE_STANDARD: { Id: "S2117", Content: "standard" },
    LOADS_TYPE_SEISMIC: { Id: "S2118", Content: "seismic" },
    LOADS_TYPE_FIRE: { Id: "S2119", Content: "fire" },
    SUSTAINED_LOAD: { Id: "S1919", Content: "Sustained load" },
    FIRE_DURATION_MINUTES: { Id: "S684", Content: "minutes" },
    SEISMIC_LOADS: {
        Id: "S925",
        Content: "Seismicity level acc. to National Annex of En 1988-1"
    },
    SEISMICITY_LEVEL_AS5216: {
        Id: "S2167",
        Content: "Crack width vs. seismic performance category according to AS5216 Table F.3.1"
    },

    BUILDING_IMPORTANCE_CLASSES: { Id: "S926", Content: "Building importance classes" },
    BUILDING_IMPORTANCE_LEVEL: { Id: "S2168", Content: "Building importance level" },
    TYPE_OF_CONNECTIONS: { Id: "S927", Content: "Type of connections" },
    SEISMIC_LOADS_STRUCTURAL: { Id: "S928", Content: "Structural Elements" },
    SEISMIC_LOADS_NON_STRUCTURAL: { Id: "S929", Content: "Non-Structural Elements" },
    TYPE_OF_PERFORMANCE: { Id: "S1923", Content: "Type of performance" },
    SEISMIC_LOADS_CATEGORY_C1: { Id: "S1924", Content: "Category C1" },
    SEISMIC_LOADS_CATEGORY_C2: { Id: "S1925", Content: "Category C2" },
    SEISMIC_LOADS_DESIGN_OPTIONS: { Id: "S1926", Content: "Design options" },
    PROTECT_AGAINST_TENSION_FAILURE: {
        Id: "L1927",
        Content: "Design option to protect against nonductile tension failure:"
    },
    SELECT_DESIGN_OPTION: { Id: "S1928", Content: "Select a design option" },
    ANCHOR_DUCTILITY_REQUIREMENTS: { Id: "S1929", Content: "Anchor ductility requirements " },
    SEISMIC_LOAD_OPTION: { Id: "S1930", Content: "Option 17.2.3.4.3(a)" },
    CAPACITY_DESIGN_OPTION: { Id: "S1931", Content: "Capacity design Option 17.2.3.4.3(b)" },
    ELASTIC_DESIGN: { Id: "S1932", Content: "Elastic design" },
    ELASTIC_DESIGN_OPTION: { Id: "S1933", Content: "Option 17.2.3.4.3(c)" },
    ELASTIC_DESIGN_OPTION_D: { Id: "S1934", Content: " Option 17.2.3.4.3(d)" },
    PROTECT_AGAINST_SHEAR_FAILURE: {
        Id: "L1935",
        Content: "Design option to protect against premature shear failure:"
    },
    CAPACITY_DESIGN_OPTION_A: {
        Id: "S1936",
        Content: "Capacity design Option 17.2.3.5.3(a)"
    },
    ELASTIC_DESIGN_OPTION_B: { Id: "S1937", Content: "Option 17.2.3.5.3(b)" },
    ELASTIC_DESIGN_OPTION_C: { Id: "S1938", Content: "Option 17.2.3.5.3(c)" },

    SEISMIC_OPTION_D4_3_5_3_a: { Id: "S2104", Content: "Option D4.3.5.3 (a)" },
    SEISMIC_OPTION_D4_3_5_3_b: { Id: "S2105", Content: "Option D4.3.5.3 (b)" },
    SEISMIC_OPTION_D4_3_5_3_c: { Id: "S2106", Content: "Option D4.3.5.3 (c)" },
    SEISMIC_OPTION_D4_3_5_3_d: { Id: "S2107", Content: "Option D4.3.5.3 (d)" },
    SEISMIC_OPTION_D4_3_6_3_a: { Id: "S2108", Content: "Option D4.3.6.3 (a)" },
    SEISMIC_OPTION_D4_3_6_3_b: { Id: "S2109", Content: "Option D4.3.6.3 (b)" },
    SEISMIC_OPTION_D4_3_6_3_c: { Id: "S2110", Content: "Option D4.3.6.3 (c)" },
    SEISMIC_LOADS_INSTALLATION: { Id: "S2125", Content: "Installation" },
    CAPACITY_DESIGN: { Id: "S1939", Content: "Capacity design" },
    FILLED_HOLES_DESCRIPTION: {
        Id: "L1940",
        Content: " Filled holes" +
            "(if the annular gap is filled," +
            "the seismic resistance in shear will not be reduced with the"
    },

    FILLED_HOLES_DESCRIPTION2: { Id: "L1941", Content: "gap factor)" },

    LIMITING_DISPLACEMENT: { Id: "L936", Content: "Limiting displacement" },
    DISPLACEMENT_VALUES_FOR_DAMAGE_LIMITATION: {
        Id: "L937",
        Content: "Displacement values for the Damage Limitation State acc. to the ETA"
    },

    DISPLACEMENT_VALUES_FOR_DAMAGE: {
        Id: "L1942",
        Content: "Displacement values for the Damage required for your application"
    },

    DLS_TENSION: { Id: "L939", Content: "DLS tension" },
    DLS_SHEAR: { Id: "L940", Content: "DLS shear" },

    LOADS_MAP: { Id: "S460", Content: "Map" },
    LOADS_ZIP_CODE: { Id: "S986", Content: "ZIP code:" },
    LOADS_TOWN: { Id: "S987", Content: "Town:" },
    LOADS_ZONE: { Id: "S988", Content: "Zone:" },
    LOADS_SEISMIC_FRANCE_DESC: { 
        Id: "S946", 
        Content: "The seismic zoning of France, in force as of the 1st of May, 2011 as defined by Decree No. 2010-1255 " +
            "of 22 October 2010. It divided France in 5 zones of increasing seismicity:"
    },
    LOADS_SEISMIC_ZONE_1: { Id: "S947", Content: "Zone 1: very low seismicity" },
    LOADS_SEISMIC_ZONE_2: { Id: "S948", Content: "Zone 2: low seismicity" },
    LOADS_SEISMIC_ZONE_3: { Id: "S949", Content: "Zone 3: moderate seismicity" },
    LOADS_SEISMIC_ZONE_4: { Id: "S950", Content: "Zone 4: average seismicity" },
    LOADS_SEISMIC_ZONE_5: { Id: "S951", Content: "Zone 5: strong seismicity" },
    LOADS_WIND_FRANCE_DESC: { 
        Id: "S2212", 
        Content: "The wind regions in France are divided into 4 zones according to the national annex NF EN 1991-4/NA March 2008"
    },
    LOADS_WIND_ZONE_1: { Id: "S2213", Content: "Zone 1: Vb = 22 m/s" },
    LOADS_WIND_ZONE_2: { Id: "S2214", Content: "Zone 2: Vb = 24 m/s" },
    LOADS_WIND_ZONE_3: { Id: "S2215", Content: "Zone 3: Vb = 26 m/s" },
    LOADS_WIND_ZONE_4: { Id: "S2216", Content: "Zone 4: Vb = 28 m/s" },

    // Context menu
    CONTEXT_MENU_PASTE_COMBINATIONS: { Id: "S2163", Content: "Paste combination(s)" },

    //SafetyBarrierLocation
    SAFETY_BARRIERS_LOCATION: { Id: "S2180", Content: "Load category" },
    LOAD_PER_LENGTH_EXTERNAL_DIRECTION: {
        Id: "S224",
        Content: "Load per length - External Direction:"
    },

    DOMESTIC_AND_RESIDENTIAL_AREAS: {
        Id: "L225",
        Content: " Domestic and residential areas (A):"
    },

    OFFICE_AREAS: { Id: "L227", Content: "Office areas (B):" },
    PUBLIC_BUILDINGS_MEETING_ROOMS: {
        Id: "L228",
        Content: "Public buildings, meeting rooms (C1 to C4):"
    },

    SHOPPING_AREAS: { Id: "L229", Content: "Shopping areas (D):" },

    INDUSTRIAL_AREAS_E1: {
        Id: "L230",
        Content: " Industrial areas susceptible to accumulation loads (E1):"
    },
    INDUSTRIAL_AREAS_E2: { Id: "L231", Content: "Industrial areas (E2):" },

    STADIUM_LARGE_CROWDS_C5: {
        Id: "L232",
        Content: " Spectators facilities, stadiums, large crowds (C5):"
    },

    SAFETY_BARRIERS_INTERNAL_DIRECTION: {
        Id: "S234",
        Content: "Internal Direction:"
    },
    LABEL_CUSTOM: { Id: "L233", Content: "Custom:" },
    SAFETY_BARRIERS_LOAD_BETWEEN_POSTS: { Id: "S2151", Content: "Load between posts:" },
    SAFETY_BARRIERS_LOAD_PER_LENGTH: { Id: "S2152", Content: "Load per length:" },

    // rebar
    REBAR_LOAD_TYPE_ON_SECTION: { Id: "S738", Content: "on the section" },
    REBAR_LOAD_TYPE_PER_REBAR: { Id: "S739", Content: "per rebar" },
    WORKING_LIFE: { Id: "S2157", Content: "Working life" },
    WORKING_LIFE_50_YEARS: { Id: "S2158", Content: "50 years" },
    WORKING_LIFE_100_YEARS: { Id: "S2159", Content: "100 years" },

    //material

    //wood
    MATERIAL_WOOD_TITLE: { Id: "S2234", Content: "Wood" },
    WOOD_STRENGTH_CLASS_LABEL: { Id: "S2235", Content: "Wood strength class:" },

    //concrete
    CONCRETE_STRENGTH: { Id: "S178", Content: "Concrete strength" },
    LIGHT_WEIGHT_CONCRETE: { Id: "L1943", Content: "Light weight concrete" },
    CONDITIONS_OF_CONCRETE: { Id: "S179", Content: "Conditions of concrete" },
    CRACKED_CONCRETE_METHODS: {
        Id: "S1090",
        Content: "For Cracked Concrete use the European Design or American Design (ACI 318) methods."
    },
    THICKNESS_OF_CONCRETE: { Id: "S180", Content: "Thickness of concrete" },
    BOND_CONDITIONS: { Id: "S512", Content: "Bond conditions" },
    //DrillingAndTemperature
    TEMPERATURE: { Id: "S183", Content: "Temperature" },
    USING_DRILLING_AID: { Id: "L514", Content: "Using drilling aid" },
    DRILLING_AND_TEMPERATURE_LONG_ITEM_LABEL: { Id: "S185", Content: "Long item:" },
    DRILLING_AND_TEMPERATURE_SHORT_ITEM_LABEL: { Id: "S184", Content: "Short iem:" },

    MATERIAL_CONCRETE_TITLE: { Id: "S175", Content: "Concrete" },
    MATERIAL_MASONRY_TITLE: { Id: "S1940", Content: "Masonry" },
    MATERIAL_SERVICE_TEMPERATURE_TITLE: { Id: "S1941", Content: "Service temperature" },
    MATERIAL_DRILLING_AND_TEMPERATURE_TITLE: { Id: "S513", Content: "Drilling & temperature" },

    //masonry

    DESIGNATION_OF_MASONRY_LABEL: { Id: "L1986", Content: "Designation of masonry:" },
    DETAILS: { Id: "S1987", Content: "Details" },
    EXECUTION: { Id: "S1988", Content: "Execution" },
    RESULTS: { Id: "S1989", Content: "Results" },
    EVALUATION_OF_TESTS: { Id: "L1990", Content: "Evaluation of tests:" },
    COMPRESSIVE_STRENGTH_LABEL: { Id: "L2085", Content: "Compressive strength" },
    LENGTH_LABEL: { Id: "L2086", Content: "Length" },
    WIDTH_LABEL: { Id: "L2087", Content: "Width" },
    HEIGHT_LABEL: { Id: "L2088", Content: "Height" },
    ALL_DIMENSIONS: { Id: "S2100", Content: "All dimensions" },

    //components-DetailFields
    PRODUCT_TESTED_NAME_LABEL: { Id: "L1944", Content: "Name of product tested" },
    SIZE_LABEL: { Id: "L1945", Content: "Size" },
    CONSTRUCTION_WORK_LABEL: { Id: "L1946", Content: "Construction work" },
    BUILDING_OWNER_LABEL: { Id: "L1947", Content: "Building owner" },
    DATE_OF_TESTS_LABEL: { Id: "L1948", Content: "Date of tests" },
    PLACE_OF_TESTS_LABEL: { Id: "L1949", Content: "Place of tests" },
    TYPE_OF_STRUCTURE_LABEL: { Id: "L1950", Content: "Type of structure to be fixed" },


    //components-ExecutionFields
    TESTS_CARRIED_OUT_BY_LABEL: { Id: "L1951", Content: "Tests carried out by" },
    SUPERVISOR_TESTS_LABEL: { Id: "L1952", Content: "Tests supervised by" },
    DIAMETER_HAMMER_LABEL: { Id: "L1953", Content: "Diameter of hammer-drill bits" },
    DRILLING_DEPTH_LABEL: { Id: "L1954", Content: "Drilling depth" },
    EMBEDMENT_DEPTH_LABEL: { Id: "L1955", Content: "Embedment depth" },
    REF_TEST_RING: { Id: "L1956", Content: "Ref. test ring" },
    INSTALLATION_PROCESS_LABEL: { Id: "L1957", Content: "Installation process according to" },
    MANUFACTURER_INSTRUCTION_LABEL: { Id: "L1958", Content: "Manufacturer instruction" },
    OTHER_LABEL: { Id: "L1959", Content: "Other" },

    
    //components-ResultsTable
    RESULTS_TABLE_RESULT: { Id: "S1960", Content: "Result" },

    //components-SpitTech
    TYPE_OF_MASONRY_LABEL: { Id: "L1961", Content: "Type of masonry:" },
    CHARACTERISTICS_MASONRY_UNITS_LABEL: { Id: "L1962", Content: "Characteristics of masonry units:" },

    MATERIAL_CONDITIONS_TITLE: { Id: "S919", Content: "Conditions" },
    MATERIAL_REINFORCEMENT_AND_CONDITIONS_TITLE: { Id: "S176", Content: "Reinforcement and Conditions" },

    MATERIAL_SPIT_TECHNICAL_DATA: { Id: "S2126", Content: "SPIT Technical data" },
    MATERIAL_TECHNICAL_DATA: { Id: "S956", Content: "Technical Data" },
    MATERIAL_JOB_SITE_TEST: { Id: "S2127", Content: "Job site test" },
    MATERIAL_JOB_SITE_TEST_POPUP_CONTENT: {
        Id: "S2141",
        Content: "This function is under the responsibility of the user. The job site tests must be done according to the regulation " +
            "and supervised by third party. All information related to the test report must be filled in the section Details, Execution " +
            "and Results to assess the resistance of the tested anchor in conformity with the tests performed on job site."
    },

    //Options

    OPTIONS_SELECT_COUNTRY: { Id: "S1963", Content: "Select country" },
    OPTIONS_SELECT_STANDARD: { Id: "S1964", Content: "Select standard" },
    OPTIONS_SELECT_COUNTRY_FIRST: { Id: "S1965", Content: "Select country first" },
    OPTIONS_SELECT_PROFILE_TYPE: { Id: "S1966", Content: "Select profile type" },
    INITIALIZATION_HAS_SUCCEED: { Id: "S1967", Content: "Initialization has succeeded!" },
    OPTIONS_DEBUG_TITLE: { Id: "S2096", Content: "Debug" },

    OPTIONS_PROFILE_COMPANY_NAME: { Id: "S293", Content: "Company name:" },
    OPTIONS_PROFILE_USER_NAME: { Id: "S294", Content: "User name:" },
    OPTIONS_PROFILE_ADDRESS: { Id: "S295", Content: "Address:" },
    OPTIONS_PROFILE_PHONE_NUMBER: { Id: "S296", Content: "Phone number:" },
    OPTIONS_PROFILE_EMAIL_ADDRESS: { Id: "S297", Content: "e-mail address:" },
    OPTIONS_PROFILE_FAX_NUMBER: { Id: "S298", Content: "Fax number:" },
    OPTIONS_PROFILE_WEBSITE_ADDRESS: { Id: "S2099", Content: "Website address:" },

    //Notifications
    NOTIFICATIONS_SPECIFY_OPTIONS: { Id: "S1996", Content: "Please, specify all of the options above!" },
    NOTIFICATIONS_APP_NOT_INITIALIZED: { Id: "S1997", Content: "Application not initialized!" },
    NOTIFICATIONS_FEM_CALCULATION_CANCELLED: { Id: "S836", Content: "FEM calculation cancelled" },
    NOTIFICATION_ERROR_PROFILE_SHAPE: {
        Id: "S2089", Content: "Something went wrong with profile shape." +
            "We've sent an error report to support automatically. Sorry for the inconvenience!"
    },
    NOTIFICATION_INCORRECT_BEAM_SHAPE: { Id: "S2090", Content: "Beam shape was incorrect!" },
    NOTIFICATION_ERROR_REQUEST: { Id: "S2086", Content: "An error occured during the request:" },
    NOTIFICATION_ERROR_PLATE_SHAPE: { Id: "S2087", Content: "Plate shape is not convex!" },
    NOTIFICATION_ERROR_SCREWS: { Id: "S2088", Content: "Some screws are outside the plate!" },
    NOTIFICATION_ERROR_REPORT_SNAPSHOT: { Id: "S2111", Content: "Unable to create the report snapshot!" },
    NOTIFICATION_ERROR_PARSE_FILE: { Id: "S2161", Content: "Unable to parse imported file!" },
    NOTIFICATION_ERROR_ACCESS_CLIPBOARD: { Id: "S2162", Content: "Please allow access to clipboard data from the browser settings." },
    NOTIFICATION_ALTERNATIVE_PASTE_LOADS: { Id: "S2164", Content: "Alternative: Paste directly into the combination name textbox." },

    //components-Editor-Anchors
    LABEL_STANDARD_LAYOUTS: { Id: "L2001", Content: "Standard layouts" },
    LABEL_CUSTOM_LAYOUTS: { Id: "L2002", Content: "Custom layouts" },

    // Buttons
    BUTTONS_YES: { Id: "S807", Content: "Yes" },
    BUTTONS_NO: { Id: "S808", Content: "No" },
    BUTTONS_CANCEL: { Id: "S847", Content: "Cancel" },
    BUTTONS_START: { Id: "S2101", Content: "START" },
    LABEL_BUTTONS_CUSTOM_N: { Id: "L1992", Content: "N" },
    LABEL_BUTTONS_CUSTOM_S: { Id: "L1993", Content: "S" },
    LABEL_BUTTONS_CUSTOM_Nx: { Id: "L1994", Content: "Nx" },
    LABEL_BUTTONS_CUSTOM_Ny: { Id: "L1995", Content: "Ny" },
    LABEL_BUTTONS_CUSTOM_Sx: { Id: "L1996", Content: "Sx" },
    LABEL_BUTTONS_CUSTOM_Sy: { Id: "L1997", Content: "Sy" },
    LABEL_BUTTONS_CUSTOM_R: { Id: "L1998", Content: "R" },

    //Confirmation
    LABEL_CONFIRMATION_DISCARD_CHANGES: { Id: "L1999", Content: "Do you want to discard your changes?" },
    LABEL_CONFIRM: { Id: "L2000", Content: "Confirm" },
    // LABEL_CONFIRMATION_CANCEL: { Id: "L2001", Content: "Cancel" }, // duplicated string (BUTTONS_CANCEL)

    //components-Editor-Plate
    LABEL_PLATE_STANDARD_SHAPES: { Id: "L2003", Content: "Standard shapes" },
    LABEL_PLATE_SIDE: { Id: "L2010", Content: "Side" },

    //components-Anchors
    LABEL_ANCHORS_VERTICAL: { Id: "L2009", Content: "Vertical" },

    //components-Nav
    LABEL_NAV_PLATE: { Id: "L2004", Content: "PLATE" },
    LABEL_NAV_ANCHORS: { Id: "L2005", Content: "ANCHORS" },

    //components-PositionsTable
    LABEL_POSITIONS_TABLE_X: { Id: "L2006", Content: "X" },
    LABEL_POSITIONS_TABLE_Y: { Id: "L2007", Content: "Y" },

    //components-Spinner
    LABEL_SPINNER_LOADING: { Id: "L2008", Content: "Loading" },


    //options
    LABEL_GENERATE_DEBUG_REPORT: { Id: "L2011", Content: "Generate debug report:" },


    //Calculate
    LABEL_CONCISE_VIEW: { Id: "L2013", Content: "Concise view" },
    LABEL_DETAILED_VIEW: { Id: "L2014", Content: "Detailed view" },

    RESULTS_OF_DESIGN: { Id: "S2082", Content: "Results of design according to" },
    DESIGN_CALCULATION: { Id: "S2083", Content: "Design calculation" },
    //CalculateResultsOfDesign
    //ANZ
    LABEL_RESULTS_OF_DESIGN_ANZ: { Id: "L2012", Content: "V" },

    IMAGE_OF_THE_BLOCK_SELECTED: { Id: "S2084", Content: "Image of the block selected" },


    GENERAL_CALCULATION_PROFILE_ORIENTATION: { Id: "S2085", Content: "Profile orientation" },

    APPLICATIONS_CHANGE_CONFIRMATION: {
        Id: "S817",
        Content: "A new application will be selected, all data entered will reset. Are you sure you want to proceed ?"
    },

// DISCLAIMER
DISCLAIMER_HEADER: { Id: "S324", Content: "Disclaimer" },
DISCLAIMER_TITLE: { Id: "S304", Content: "Disclaimer:" },
DISCLAIMER_SPIT_CONTENT_1: {
    Id: "S305", 
    Content: "  SPIT can only be held responsible if the calculation models exactly reflect " +
    "the application and if the installation is carried out according to the instruction given in the ETA and the SPIT specifications. " +
    "The calculation is correct for SPIT anchors only. It is the responsibility of the contractor or specifier:\n" +
    "-  To define the base material, the intended use (with on-site tests)\n" +
    "-  To check that the supporting structure is capable of withstanding the loads borne by the anchors and that all precautions " +
    "necessary to transfer such loads have been taken, especially when anchors are arranged in groups.\n" +
    "-  To check results before using them and their conformity to the application defined by the client.\n" +
    "   SPIT cannot be held responsible if the software package is modified without its written approval " +
    "or for the improper use of this software."
},
DISCLAIMER_SPIT_CONTENT_2: {
    Id: "S734", 
    Content: "Non-Personal Data:\n\n" +

    "   When using or accessing the SPIT I-Expert website," +
    "we automatically collect non-personal data (internet browser, operating system, number of visits)." +
    "Non-personal data collected will be used to determine attractiveness of our website and to improve its content and performances." +
    "Non-personal data collected does not identify you in any way and is not shared with anyone else.\n\n" +

    "Personal Data:\n\n" +

    "   Protecting the security and privacy of your personal data is important to SPIT." +
    "We collect personal data in connection with the operation of our websites SPIT I-Expert " +
    "only when you have voluntarily provided such data to us by filling out the user profile form included in the SPIT I-Expert website. " +
    "The Personal Data collected are : name, title, address, phone, email, fax. " +
    "The personal Data collected is processed internally and exclusively for SPIT, " +
    "for the purpose of granting you access to certain information or offerings or sending you satisfaction surveys.\n\n" +

    "   SPIT Sales and Marketing Department is the personal data holder; therefore, it is responsible for their update and modification." +
    "With reference to the processing of your personal data, in accordance with law 78-17 dated 6th of January 1978 " +
    "relating to data processing, files and personal freedom and privacy, you have a right to request access to, and correct, " +
    "modify or delete your personal data by simple request." +
    "Should you wish to exercise this right, simply write to us at the following address: \n\n" +

    "   SPIT - Direction Communication – 150, Avenue de Lyon – BP 104 - 26501 Bourg-lès-Valence cedex (France).\n\n" +

    "   For further information on your rights, please visit : https://www.cnil.fr/en/home"
},

DISCLAIMER_REDHEAD_CONTENT_1: {
    Id: "S2112",

    Content: "Please visit http://www.itwredhead.com/terms.php for a full list of terms and conditions.\n" +
    "Extract from our terms and conditions:\n" +
    "1. Acceptance. Commercial Construction, a division of Illinois Tool Works Inc. (formerly operating as the separate divisions " +
    'ITW Buildex, ITW Ramset and ITW Red Head) is herein referred to as "ITW", and the customer purchasing products ("Products") or ' +
    'services ("Services") from ITW is referred to as "Purchaser." These terms and conditions of sale ("Terms"), any ITW quotation, ' +
    'acknowledgment or invoice and all documents incorporated by specific reference herein or therein ("ITW Documents" and together ' +
    'with these Terms, the "Agreement"), constitute the complete terms governing the sale of Products and Services. ITW HEREBY REJECTS ' +
    "ANY ADDITIONAL OR DIFFERENT TERMS OR CONDITIONS PROPOSED BY PURCHASER, WHETHER OR NOT CONTAINED IN ANY OF PURCHASER'S BUSINESS " +
    "FORMS OR IN PURCHASER'S WEBSITE, AND SUCH ADDITIONAL OR DIFFERENT TERMS WILL BE OF NO EFFECT. No site usage agreement or any other " +
    'click through agreement on a website will have any binding effect whether or not ITW clicks on an "ok," "I accept," or similar ' +
    "acknowledgment. Commencement of any work by ITW or Purchaser's acceptance of delivery of the Products or Services will manifest " +
    "Purchaser's assent to the Agreement. Additional or different terms applicable to a particular sale may be specified in the body of " +
    "an ITW Document, and, in the event of a conflict, will take precedence over these Terms.\n\n" +

    "15. Confidential Information. All information furnished or made available by ITW to Purchaser in connection with the subject " +
    "matter hereof shall be held in confidence by Purchaser. Purchaser agrees not to use, or disclose to others, such information " +
    "without ITW's prior written consent. The obligations in this section will not apply to any information that: (a) at the time of " +
    "disclosure was or thereafter becomes generally available to the public by publication or otherwise through no breach by Purchaser " +
    "of any obligation herein; (b) Purchaser can show by written records was in Purchaser's possession prior to disclosure by ITW; or " +
    "(c) is legally made available to Purchaser by or through a third party having no direct or indirect confidentiality obligation to " +
    "ITW with respect to such information."
},

DISCLAIMER_RAMSET_CONTENT_1: {
    Id: "S2113",
    Content: "RAMSET can only be held responsible if the calculation models exactly reflect the application and if the installation " +
        "is carried out according to the instruction given in the ETA and the RAMSET specifications. The calculation is correct for " +
        "RAMSET anchors only. It is the responsibility of the contractor or specifier:\n" +
        "\t- To define the base material, the intended use (with on-site tests)\n" +
        "\t- To check that the supporting structure is capable of withstanding the loads borne by the anchors and that all precautions " +
        "necessary to transfer such loads have been taken, especially when anchors are arranged in groups.\n" +
        "\t- To check results before using them and their conformity to the application defined by the client.\n" +
        "RAMSET cannot be held responsible if the software package is modified without its written approval or for the improper use " +
        "of this software."
},

DISCLAIMER_CANADA_CONTENT_1: {
    Id: "S2130",
Content: "Please visit http://www.itwredhead.com/terms.php for a full list of terms and conditions. " +
    "Extract from our terms and conditions:\n\n" +
    "1. Acceptance. ITW Construction Products Canada and Commercial Construction, a division of Illinois Tool Works Inc. " +
    "(formerly operating as the separate divisions " +
    'ITW Buildex, ITW Ramset and ITW Red Head) is herein referred to as "ITW", and the customer purchasing products ("Products") or ' +
    'services ("Services") from ITW is referred to as "Purchaser." These terms and conditions of sale ("Terms"), any ITW quotation, ' +
    'acknowledgment or invoice and all documents incorporated by specific reference herein or therein ("ITW Documents" and together ' +
    'with these Terms, the "Agreement"), constitute the complete terms governing the sale of Products and Services. ITW HEREBY REJECTS ' +
    "ANY ADDITIONAL OR DIFFERENT TERMS OR CONDITIONS PROPOSED BY PURCHASER, WHETHER OR NOT CONTAINED IN ANY OF PURCHASER'S BUSINESS " +
    "FORMS OR IN PURCHASER'S WEBSITE, AND SUCH ADDITIONAL OR DIFFERENT TERMS WILL BE OF NO EFFECT. No site usage agreement or any other " +
    'click through agreement on a website will have any binding effect whether or not ITW clicks on an "ok," "I accept," or similar ' +
    "acknowledgment. Commencement of any work by ITW or Purchaser's acceptance of delivery of the Products or Services will manifest " +
    "Purchaser's assent to the Agreement. Additional or different terms applicable to a particular sale may be specified in the body of " +
    "an ITW Document, and, in the event of a conflict, will take precedence over these Terms.\n\n" +

    "15. Confidential Information. All information furnished or made available by ITW to Purchaser in connection with the subject " +
    "matter hereof shall be held in confidence by Purchaser. Purchaser agrees not to use, or disclose to others, such information " +
    "without ITW's prior written consent. The obligations in this section will not apply to any information that: (a) at the time of " +
    "disclosure was or thereafter becomes generally available to the public by publication or otherwise through no breach by Purchaser " +
    "of any obligation herein; (b) Purchaser can show by written records was in Purchaser's possession prior to disclosure by ITW; or " +
    "(c) is legally made available to Purchaser by or through a third party having no direct or indirect confidentiality obligation to " +
    "ITW with respect to such information."
},

    DISCLAIMER_AGREE: { Id: "S364", Content: "I agree" },

    // PRIVACY POLICY
    PRIVACY_POLICY_HEADER: { Id: "S731", Content: "About Privacy Policy - Data processing and use" },

    // SUPPORT
    SUPPORT_CONTENT: {
        Id: "S641",
        Content: "For issues related to software and engineering support, please contact our Technical Service Department:"
    },
    SUPPORT_TECHNICAL_SUPPORT: { Id: "S306", Content: "Technical support:" },
    SUPPORT_WEBSITE_1: { Id: "S307", Content: "www.spit.fr" },
    SUPPORT_WEBSITE_2: { Id: "S308", Content: "www.spit.com" },
    SUPPORT_HOURS: { Id: "S2123", Content: "Hours:" },

    // ABOUT
    ABOUT_SOFTWARE_VERSION: { Id: "S303", Content: "Software version:" },
    ABOUT_DATABASE_VERSION: { Id: "S730", Content: "Database version:" },
    ABOUT_TRANSLATION_DISCLAIMER: {
        Id: "S862",
        Content: "This application has been translated in several languages. If in doubt about the significance or accuracy " +
            "of the technical terms used, thank you to check out the English version (menu Options - Country / Language), " +
            "which is the reference version."
    },
    ABOUT_DEVELOPED_WITH_GRAITEC: { Id: "S863", Content: "Developed in collaboration with Graitec" },
    ABOUT_COPYRIGHT: {
        Id: "S2114",
        Content: "This application make use of PDFsharp, an Open Source .NET Library, " +
            "published by empira Software GmbH under the MIT License.\n\n" +
            "This application generates reports using the ActiveReports software, published by GrapeCity, Inc. " +
            "and licensed as a Standard Developer License."
    },

    // Wood Connection Components
    WOOD_CONNECTION_HOLE_DIAMETER: { Id: "S2189", Content: "Hole Ø" },
    WOOD_CONNECTION_HOLE_SPACING_SC: { Id: "S2236", Content: "SC =" },
    WOOD_CONNECTION_ENABLE_COORDINATES: { Id: "S2190", Content: "Enable Custom Coordinates" },
    WOOD_CONNECTION_COORDINATES_TABLE_INDEX: { Id: "S2191", Content: "#" },
    WOOD_CONNECTION_COORDINATES_TABLE_X: { Id: "S2192", Content: "X (mm)" },
    WOOD_CONNECTION_COORDINATES_TABLE_Y: { Id: "S2193", Content: "Y (mm)" },

    // Bracket Component
    WOOD_CONNECTION_BRACKET_BASE_PLATE: { Id: "S2194", Content: "Dimensions of the plate" },
    WOOD_CONNECTION_BRACKET_THICKNESS: { Id: "S2195", Content: "Thickness" },
    WOOD_CONNECTION_BRACKET_DIM_A: { Id: "S2196", Content: "A" },
    WOOD_CONNECTION_BRACKET_DIM_B: { Id: "S2197", Content: "B" },
    WOOD_CONNECTION_BRACKET_DIM_C: { Id: "S2198", Content: "C" },
    WOOD_CONNECTION_BRACKET_DIM_D: { Id: "S2225", Content: "D" },
    WOOD_CONNECTION_BRACKET_DIM_T: { Id: "S2199", Content: "t" },

    // Spacing Configuration
    WOOD_CONNECTION_SPACING_S1: { Id: "S2200", Content: "S1" },
    WOOD_CONNECTION_SPACING_S2: { Id: "S2201", Content: "S2" },
    WOOD_CONNECTION_SPACING_S3: { Id: "S2202", Content: "S3" },
    WOOD_CONNECTION_SPACING_C1TOP: { Id: "S2203", Content: "C1/top" },
    WOOD_CONNECTION_SPACING_C2TOP: { Id: "S2204", Content: "C2/top" },
    WOOD_CONNECTION_SPACING_C3TOP: { Id: "S2205", Content: "C3/top" },
    WOOD_CONNECTION_SPACING_NP: { Id: "S2206", Content: "N x P" },

    // Wood Connection Tab Names
    WOOD_CONNECTION_TAB_BRACKET: { Id: "S2207", Content: "Bracket" },
    WOOD_CONNECTION_TAB_HOLES_CONFIG: { Id: "S2209", Content: "Holes Configuration on flange A" },
    WOOD_CONNECTION_TAB_HOLES_CONFIG_B: { Id: "S2210", Content: "Holes Configuration on flange B" },


    WOOD_CONNECTION_NAIL_PATTERN: { Id: "S2220", Content: "Nail pattern" },
    WOOD_CONNECTION_FULL_NAILING_PATTERN: { Id: "S2221", Content: "Full nailing pattern" },
    WOOD_CONNECTION_PARTIAL_NAILING_PATTERN: { Id: "S2222", Content: "Partial nailing pattern" },
    WOOD_CONNECTION_LOAD_APPLIED_ON_BRACKET: { Id: "S2223", Content: "Load applied on the bracket" },
    WOOD_CONNECTION_LOAD_APPLIED_ON_BRACKET_N: { Id: "S2237", Content: "n =" },
    WOOD_CONNECTION_UPLIFT_LOAD_FAX_D: { Id: "S2238", Content: "Uplift load Fax,d" },
    WOOD_CONNECTION_STATIC_LOAD: { Id: "S2244", Content: "Static" },
    WOOD_CONNECTION_SEISMIC_LOAD: { Id: "S2245", Content: "Seismic C1" },
    WOOD_CONNECTION_KMOD_FACTOR: { Id: "S2246", Content: "kmod factor" },

    // Wood Connection Design
    WOOD_CONNECTION_DESIGN_ANCHORS: {
        Id: "S2218",
        Content: "Anchors in concrete according EN 1992-4 and connector nails according to EC5"
    },
    WOOD_CONNECTION_DESIGN_EMBEDMENT_DEPTH: { Id: "S2219", Content: "Embedment depth for anchor" },
    CALCULATE_NAILS_INTERACTION: { Id: "S2224", Content: "Interaction" },
    CALCULATE_EUROCODE5_TITLE: { Id: "S2226", Content: "Result of design according to Eurocode 5" },
    CALCULATE_EUROCODE5_LOADS_ON_NAILS: { Id: "S2227", Content: "Loads on nails Fax,d :" },
    CALCULATE_EUROCODE5_FRD: { Id: "S2228", Content: "FRd wood/connector :" },
    CALCULATE_NAIL_HEADER_TITLE: { Id: "S2229", Content: "Nail selected" },
    CALCULATE_NAIL_HEADER_DESIGN_METHOD: { Id: "S2230", Content: "Design Method:" }

};
// XXX: { Id:"xxx", Content:"xxx"},



export function loadTranslations() {
    // duplicate IDs
    // var duplicates = [];
    // Object.values(APP_TEXTS).map(obj => { return obj.Id; }).filter((value, index, array) => {
    //     if (index !== array.findIndex((val) => { return val === value; }))
    //         duplicates.push(value);
    // });
    // console.log("Duplicates: " + duplicates);

    return translationService.getTranslations(Object.values(APP_TEXTS).map(obj => obj.Id)).then(t => {
        if (t && t.length) {
            // var key;
            // for (key of Object.keys(APP_TEXTS)) {
            Object.keys(APP_TEXTS).forEach((key) => {
                let found = t.find(o => o.InternalName === APP_TEXTS[key].Id);
                if (found !== undefined && found !== null && found.RunName != null)
                    APP_TEXTS[key].Content = found.RunName;
            });
            // }
        }
    });
}

export function getText(tId) {
    let found = Object.values(APP_TEXTS).find(t => t.Id === tId);
    if (found !== undefined)
        return found.Content;
    return "NF";
}



// WEBPACK FOOTER //
// ./src/texts/texts.js